import { _ as u, b as d } from "./getButtonHref-4b514703.js";
import o from "react";
import { c as b, _ as y } from "./extends-2c39a7b4.js";
import { u as N } from "./pp-react-theme.esm-ef1d004f.js";
import { S as I } from "./pp-react-utils.esm-093ddd7e.js";
var p = { "ppvx_text--xl8": "ppvx_text--xl8___5-7-5", "ppvx_text--xl7": "ppvx_text--xl7___5-7-5", "ppvx_text--xl6": "ppvx_text--xl6___5-7-5", "ppvx_text--xl5": "ppvx_text--xl5___5-7-5", "ppvx_text--xl4": "ppvx_text--xl4___5-7-5", "ppvx_text--xl3": "ppvx_text--xl3___5-7-5", "ppvx_text--xl2": "ppvx_text--xl2___5-7-5", "ppvx_text--xl": "ppvx_text--xl___5-7-5", "ppvx_text--lg": "ppvx_text--lg___5-7-5", "ppvx_text--md": "ppvx_text--md___5-7-5", "ppvx_text--sm": "ppvx_text--sm___5-7-5", "ppvx_text--xs": "ppvx_text--xs___5-7-5", "ppvx_text--regular": "ppvx_text--regular___5-7-5", "ppvx_text--medium": "ppvx_text--medium___5-7-5", "ppvx_text--caption": "ppvx_text--caption___5-7-5", "ppvx_text--caption-strong": "ppvx_text--caption-strong___5-7-5", "ppvx_text--body": "ppvx_text--body___5-7-5", "ppvx_text--body-strong": "ppvx_text--body-strong___5-7-5", "ppvx_text--heading-xs": "ppvx_text--heading-xs___5-7-5", "ppvx_text--heading-sm": "ppvx_text--heading-sm___5-7-5", "ppvx_text--heading-md": "ppvx_text--heading-md___5-7-5", "ppvx_text--heading-lg": "ppvx_text--heading-lg___5-7-5", "ppvx_text--hero": "ppvx_text--hero___5-7-5", "ppvx_text--beta-title": "ppvx_text--beta-title___5-7-5", "ppvx_text--beta-heading-xs": "ppvx_text--beta-heading-xs___5-7-5", "ppvx_text--beta-heading-sm": "ppvx_text--beta-heading-sm___5-7-5", "ppvx_text--beta-heading-md": "ppvx_text--beta-heading-md___5-7-5", "ppvx_text--beta-heading-lg": "ppvx_text--beta-heading-lg___5-7-5", "ppvx_text--beta-display-lg": "ppvx_text--beta-display-lg___5-7-5", "ppvx_text--shimmer": "ppvx_text--shimmer___5-7-5", "ppvx--v2": "ppvx--v2___5-7-5", "ppvx--v1": "ppvx--v1___5-7-5" }, S = ["level", "as", "size", "className", "theme", "isLoading", "isInverse", "children"], T = function(e, t, x) {
  if (x)
    return x;
  if (t)
    switch (e) {
      case 1:
        return "lg";
      case 2:
        return "sm";
      default:
        return "lg";
    }
  switch (e) {
    case 1:
      return "lg";
    case 2:
      return "md";
    case 3:
      return "sm";
    default:
      return "md";
  }
}, H = function(e) {
  var t, x = e.level, n = e.as, a = n === void 0 ? x ? "h".concat(x) : "div" : n, c = e.size, h = e.className, v = e.theme, l = e.isLoading, i = e.isInverse, m = e.children, r = u(e, S), _ = N("HeadingText", v), s = _ && _ === "v2", g = T(x, s, c), L = b((t = {}, d(t, p["ppvx_text--heading-".concat(g)], g !== "hero"), d(t, p["ppvx_text--hero"], g === "hero"), t), h, s && p["ppvx--v2"], s && l && p["ppvx_text--shimmer"]);
  return s && l ? /* @__PURE__ */ o.createElement(I, {
    className: L,
    hasStyleDefaults: !1,
    isInverse: i
  }, m) : /* @__PURE__ */ o.createElement(a, y({
    className: L
  }, r), m);
}, E = ["as", "strong", "className", "theme", "isLoading", "isInverse", "children"], V = function(e) {
  var t, x = e.as, n = x === void 0 ? "div" : x, a = e.strong, c = e.className, h = e.theme, v = e.isLoading, l = e.isInverse, i = e.children, m = u(e, E), r = N("BodyText", h), _ = r && r === "v2", s = b((t = {}, d(t, p["ppvx_text--body"], !a), d(t, p["ppvx_text--body-strong"], a), t), c, _ && p["ppvx--v2"], _ && v && p["ppvx_text--shimmer"]);
  return _ && v ? /* @__PURE__ */ o.createElement(I, {
    className: s,
    hasStyleDefaults: !1,
    isInverse: l
  }, i) : /* @__PURE__ */ o.createElement(n, y({
    className: s
  }, m), i);
}, $ = ["as", "strong", "className", "theme", "isLoading", "isInverse", "children"], w = function(e) {
  var t, x = e.as, n = x === void 0 ? "div" : x, a = e.strong, c = e.className, h = e.theme, v = e.isLoading, l = e.isInverse, i = e.children, m = u(e, $), r = N("CaptionText", h), _ = r && r === "v2", s = b((t = {}, d(t, p["ppvx_text--caption"], !a), d(t, p["ppvx_text--caption-strong"], a), t), c, _ && p["ppvx--v2"], _ && v && p["ppvx_text--shimmer"]);
  return _ && v ? /* @__PURE__ */ o.createElement(I, {
    className: s,
    hasStyleDefaults: !1,
    isInverse: l
  }, i) : /* @__PURE__ */ o.createElement(n, y({
    className: s
  }, m), i);
};
export {
  V as B,
  w as C,
  H
};
//# sourceMappingURL=pp-react-text.esm-fc0bee1c.js.map
